"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var feedback_1 = require("../actions/feedback");
var models_1 = require("../models");
function feedback(state, action) {
    if (state === void 0) { state = { sentiment: models_1.FeedbackSentiment.unspecified }; }
    if (action.type === feedback_1.Actions.update) {
        return action.feedback;
    }
    return state;
}
exports.feedback = feedback;
//# sourceMappingURL=feedback.js.map